import PanelContent from "components/Shared/Filters/modules/components"
import Select from "components/Shared/Filters/Select"
import React from "react"
import { Tuple } from "components/Shared/Interfaces"
import ErrorMessage from "../ErrorMessage"

interface SelectWithValidatorProps {
	id: string
	data: any
	setData: (value: any) => void
	isDisabled?: boolean
	options: Tuple[]
	isLoading?: boolean
}

const SelectWithValidator: React.FC<SelectWithValidatorProps> = ({
	id,
	data,
	setData,
	isDisabled,
	options,
	isLoading,
}) => {
	const setSelectErrorColor = (list: Tuple[]) => {
		return list.length <= 0 && "on-error"
	}

	return (
		<div className={`text-field ${setSelectErrorColor(data[id])}`}>
			<PanelContent
				id={`usermanagement.organizations.${id}`}
				selectedValues={data[id]}
				isDisabled={isDisabled}
				selectedLabel={`phronesis.filters.usermanagement.organizations.${id}.labels.selected`}
			>
				<Select
					id={id}
					options={options}
					onChange={(value) =>
						setData({
							...data,
							[id]: value.filter((item) => item.code !== "0"),
						})
					}
					isClearable={true}
					hasTitle={false}
					isMulti={true}
					isDisabled={isDisabled}
					allOption
					isLoading={isLoading}
				/>
				<ErrorMessage items={data[id]} />
			</PanelContent>
		</div>
	)
}

export default SelectWithValidator
